"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  .title-container {\n    position: relative;\n    .tooltip {\n      display: none;\n      position: absolute;\n      background-color: ", ";\n      color: ", ";\n      font-family: ", ";\n      font-size: 14px;\n      line-height: 19px;\n      left: 0;\n      top: 0;\n      height: fit-content;\n      transition: display 2s;\n    }\n\n    &:hover {\n      .tooltip {\n        display: block;\n      }\n    }\n  }\n\n  & > :first-child {\n    & + * {\n      margin-top: ", "px;\n    }\n  }\n  & + * {\n    margin-top: ", "px;\n  }\n"])), _variables.GlobalColors.white, function (_ref) {
  var color = _ref.color;
  return color ? color : _variables.GlobalColors.s5;
}, _variables.FontFamily.Raleway, function (_ref2) {
  var inputType = _ref2.inputType;
  return inputType !== "textarea" ? 4 : 15;
}, function (_ref3) {
  var inputType = _ref3.inputType;
  return inputType !== "textarea" ? 0 : 10;
});

exports.Container = Container;